import "../App.css";
import tdCoins from "../images/table_division_coins_binary.png";
import tdExAfter from "../images/table_division_exchange_after_binary_marked.png";
import tdExBefore from "../images/table_division_exchange_before_binary_marked.png";
import tdSolLeft from "../images/table_division_sol_left_binary_marked.png";
import tdSolRight from "../images/table_division_sol_right_binary_marked.png";
import tdTask from "../images/table_division_task_binary_marked.png";
import {
  tutorial7Binary1,
  tutorial7Binary10,
  tutorial7Binary11,
  tutorial7Binary12,
  tutorial7Binary2,
  tutorial7Binary3,
  tutorial7Binary4,
  tutorial7Binary5,
  tutorial7Binary6,
  tutorial7Binary7,
  tutorial7Binary8,
  tutorial7Binary9,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel,
  tutorialTitle
} from "../strings";

function Tutorial7Binary({ finishTutorial, page, handleNext, handlePrevious }) {

  const maxPages = 8; // Note that the first page has index 0. This means maxPages-1 is the last page.

  return (
    <div>
      <div style={{height: "65dvh"}}> {/* Table Division tutorials are the only ones with increased height. */}
        <div className="tutorial-title">
          {tutorialTitle}
        </div>
        <div className="tutorial-body" style={{height: "35dvh"}}>
          {page === 0 && 
            <div>
              {tutorial7Binary1}
              <br></br>&nbsp;<br></br>
              {tutorial7Binary2}
            </div>
          }
          {page === 1 && 
            <div style={{fontSize: "2dvh"}}>
              {tutorial7Binary3}
              <br></br>&nbsp;<br></br>
              <img src={tdCoins} alt="table-division-coins" style={{width: "50dvh"}}/>
              <br></br>&nbsp;<br></br>
              {tutorial7Binary4}
            </div>
          }
          {page === 2 && 
            <div style={{fontSize: "2dvh"}}>
              {tutorial7Binary5}
              <br></br>&nbsp;<br></br>
              <img src={tdTask} alt="table-division-task" style={{width: "45dvh"}}/>
            </div>
          }
          {page === 3 && 
            <div style={{fontSize: "2dvh"}}>
              {tutorial7Binary6}
              <br></br>&nbsp;<br></br>
              <div style={{display: "flex", flexDirection: "row", gap: "2dvh", justifyContent: "center"}}>
                <img src={tdSolLeft} alt="table-division-sol-left" style={{width: "30dvh"}}/>
                <img src={tdSolRight} alt="table-division-sol-right" style={{width: "43dvh"}}/>
              </div>
            </div>
          }
          {page === 4 && 
            <div>
              {tutorial7Binary7}
              <br></br>&nbsp;<br></br>
              {tutorial7Binary8}
            </div>
          }
          {page === 5 && 
            <div style={{fontSize: "2dvh"}}>
              {tutorial7Binary9}
              <br></br>&nbsp;<br></br>
              <div style={{display: "flex", flexDirection: "row", gap: "1dvh", justifyContent: "center"}}>
                <img src={tdExBefore} alt="table-division-ex-before" style={{width: "33dvh"}}/>
                <span style={{display: "flex", alignItems: "center", fontSize: "8dvh"}}>&#10137;</span>
                <img src={tdExAfter} alt="table-division-ex-after" style={{width: "33dvh"}}/>
              </div>
            </div>
          }
          {page === 6 && 
            <div>
              {tutorial7Binary10}
              <br></br>&nbsp;<br></br>
              {tutorial7Binary11}
            </div>
          }
          {page === 7 && 
            <div>
              {tutorial7Binary12}
            </div>
          }
        </div>
      </div>

      {/* Button to start level. */}
      {page === (maxPages-1) && 
        <button
        onClick={finishTutorial}
          className="tutorial-next-button"
        >
        {tutorialButtonStartLevel}
        </button>
      }

      {/* Button to go to previous page. */}
      {page > 0 && 
        <button
          onClick={handlePrevious}
          className="tutorial-previous-button"
        >
        {tutorialButtonPreviousPage}
        </button>
      }

      {/* Button to go to next page. */}
      {page < (maxPages-1) && 
        <button
          onClick={handleNext}
          className="tutorial-next-button"
        >
        {tutorialButtonNextPage}
        </button>
      }
    </div>
  );
}

export default Tutorial7Binary;
